var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeakerFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 3.5a3 3 0 1 1 0 6 3 3 0 0 1 0-6Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 17.25C4 14.35 6.35 12 9.25 12h2.5C14.65 12 17 14.35 17 17.25V18.5A1.5 1.5 0 0 1 15.5 20h-10A1.5 1.5 0 0 1 4 18.5v-1.25Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 8.25c.97.78 1.5 1.92 1.5 3.25s-.53 2.47-1.5 3.25l1.25 1.56C18.3 15.78 19 14 19 12s-.7-3.78-2.25-4.31L15.5 8.25Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 6.5c1.58 1.2 2.5 3.04 2.5 5.5s-.92 4.3-2.5 5.5l1.25 1.56C20.93 17.2 22 14.79 22 12s-1.07-5.2-3.25-7.06L17.5 6.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakerFilled);
export default __webpack_public_path__ + "static/media/SpeakerFilled.10c6656c193b11594c0e4bc5c6216123.svg";
export { ForwardRef as ReactComponent };